import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  mode: 'archive' | 'unarchive';
  companyName: string;
  busy?: boolean;
  onConfirm: () => Promise<void> | void;
}

/**
 * ArchiveCompanyDialog — Plan 02-09 must_haves.truths pin the archive warning
 * copy EXACTLY. Do not paraphrase, do not reorder. The corresponding string
 * is asserted verbatim in CompaniesPage.test.tsx.
 *
 * Unarchive mode uses a neutral copy and flips the confirm label; no warning
 * text is needed because unarchiving is a reversible, non-destructive op.
 */
export function ArchiveCompanyDialog({
  open,
  onOpenChange,
  mode,
  companyName,
  busy,
  onConfirm,
}: Props) {
  const isArchive = mode === 'archive';
  const title = isArchive ? `Archive ${companyName}?` : `Unarchive ${companyName}?`;
  const description = isArchive
    ? `Archive ${companyName}? Historical tickets, sessions, and billing records will be preserved.`
    : `Unarchive ${companyName}? The company will be visible in the active list again.`;
  const confirmLabel = isArchive ? 'Archive' : 'Unarchive';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" variant="ghost" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            type="button"
            variant={isArchive ? 'destructive' : 'default'}
            disabled={busy}
            onClick={() => void onConfirm()}
          >
            {busy ? 'Saving…' : confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
